import React from "react";
import Popup1Stamp from "../assets/images/scanpoint/popup_1_stamp.png";
import Popup5Points from "../assets/images/scanpoint/popup_5_points.png";

function StreakRewardPopup({ type, onClose }) {
  if (type !== "stamp" && type !== "complete") {
    return null;
  }

  const isComplete = type === "complete";
  const imageSrc = isComplete ? Popup5Points : Popup1Stamp;
  const alt = isComplete
    ? "ยินดีด้วย ครบภารกิจ 5 วัน รับโบนัส 5 คะแนน"
    : "ยินดีด้วย คุณได้รับแสตมป์ 1 ดวง";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
      role="dialog"
      aria-modal="true"
      aria-label={alt}
    >
      <div style={{ position: "relative", width: "90%", maxWidth: "400px" }}>
        <div
          onClick={onClose}
          role="button"
          tabIndex={0}
          aria-label="ปิด"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onClose();
          }}
          style={{
            position: "absolute",
            top: "-2%",
            right: "-2%",
            width: "15%",
            height: "10%",
            cursor: "pointer",
            zIndex: 10,
          }}
        />

        <img src={imageSrc} alt={alt} style={{ width: "100%", display: "block" }} />

        {isComplete && (
          <div
            onClick={onClose}
            role="button"
            tabIndex={0}
            aria-label="ยืนยัน"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onClose();
            }}
            style={{
              position: "absolute",
              bottom: "6%",
              left: "50%",
              transform: "translateX(-50%)",
              width: "55%",
              height: "12%",
              cursor: "pointer",
              zIndex: 10,
            }}
          />
        )}
      </div>
    </div>
  );
}

export default StreakRewardPopup;

/**
 * @param {number} previousDisplayStreak — stamp count shown on banner before this scan
 *   (not raw DB stored streak; after a gap the banner shows 0 while stored may still be > 0)
 */
export function resolveStreakPopupType(scanResult, previousDisplayStreak = 0) {
  const items = scanResult?.streak ?? [];
  if (!items.length) {
    return null;
  }

  const hasFiveDayReward = items.some((item) =>
    (item.rewardsGranted ?? []).some((reward) => Number(reward.dayTarget) === 5),
  );
  if (hasFiveDayReward) {
    return "complete";
  }

  const scanStreak = items
    .map((item) => Number(item?.currentStreak))
    .filter((value) => Number.isFinite(value));

  const nextStreak = scanStreak.length ? Math.max(...scanStreak) : 0;
  const prevDisplay = Number(previousDisplayStreak) || 0;

  if (nextStreak > prevDisplay) {
    return "stamp";
  }

  return null;
}
